import { render, staticRenderFns } from "./DiscountPolicyTab.vue?vue&type=template&id=0b179eb6&scoped=true"
import script from "./DiscountPolicyTab.vue?vue&type=script&lang=js"
export * from "./DiscountPolicyTab.vue?vue&type=script&lang=js"
import style0 from "./DiscountPolicyTab.vue?vue&type=style&index=0&id=0b179eb6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b179eb6",
  null
  
)

export default component.exports